export default {
  path: '/profile_strategies',
  name: 'profile_strategies',
  component: () => import('../components/profilestrategy/Layout'),
  redirect: { name: 'ProfileStrategyList' },
  meta: {
    breadcrumb: 'profile.strategy.strategies',
  },
  children: [
    {
      name: 'ProfileStrategyList',
      path: '',
      component: () => import('../views/profilestrategy/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProfileStrategyCreate',
      path: 'new',
      component: () => import('../views/profilestrategy/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProfileStrategyUpdate',
      path: ':id/edit',
      component: () => import('../views/profilestrategy/Update'),
      meta: {
        breadcrumb: 'profile.strategy.strategy',
      },
    },
    {
      name: 'ProfileStrategyShow',
      path: ':id',
      component: () => import('../views/profilestrategy/Show'),
      meta: {
        breadcrumb: 'profile.strategy.strategy',
      },
    },
    {
      name: 'ProfileStrategy',
      path: ':parent',
      component: () => import('../components/profilestrategyquality/Layout'),
      meta: {
        breadcrumb: 'profile.strategy.strategy',
      },
      children: [
        {
          name: 'ProfileStrategyQualityShow',
          path: ':id',
          component: () => import('../views/profilestrategyquality/Show'),
          meta: {
            breadcrumb: 'profile.strategy.quality',
          },
        },
        {
          name: 'ProfileStrategyQualityUpdate',
          path: ':id/edit',
          component: () => import('../views/profilestrategyquality/Update'),
          meta: {
            breadcrumb: 'profile.strategy.quality',
          },
        },
        {
          name: 'ProfileStrategyQualityCreate',
          path: 'new',
          component: () => import('../views/profilestrategyquality/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
